class Plan {
    constructor() {
        this.code = null;
        this.frequency = null;
    }
}
class Subscription extends Plan {
    constructor() {
        super(...arguments);
        this.serviceOffer = null;
        this.status = null;
        /**
         * If Set it means the current plan will not be renewed and will end at this date.
         * Warning : Cancel subscription on samples will have endDate but no Next Plan
         */
        this.endDate = null;
        /**
         * Date of renewal for an ongoing subscription, or when the next subscription will start
         */
        this.renewalDate = null;
    }
}
class SubscriptionNext extends Plan {
    constructor() {
        super(...arguments);
        this.startDate = null;
    }
}
const keysOfSubscription = ["serviceOffer", "status", "endDate", "renewalDate", "code", "frequency"];
const keysOfSubscriptionNext = ["startDate", "code", "frequency"];

export { Plan, Subscription, SubscriptionNext, keysOfSubscription, keysOfSubscriptionNext };
